import { ROUTES } from "@/@core/constants/routes";
import { Checkbox } from "@/components/ui/checkbox";
import { useGetQuote } from "@/context/quote-venue/GetQuoteData";

export default function QuoteUsageTerms() {
    const { userData, onChange } = useGetQuote();

    return (
        <label className="flex gap-2 items-center font-medium text-assistant text-xs">
            <Checkbox
                checked={userData.isAgreed}
                onCheckedChange={() => {
                    onChange("userData", "isAgreed", !userData.isAgreed);
                }}
                className="border-assistant checked:bg-assistant rounded-full w-6 h-6 duration-200"
            />

            <div>
                <a target="_blank" href={ROUTES.LEGAL.TERMS} className="underline">
                    Kullanım Koşullarını
                </a>{" "}
                ve{" "}
                <a target="_blank" href={ROUTES.LEGAL.WARNING} className="underline">
                    Gizlilik Sözleşmesini
                </a>{" "}
                okudum, kabul ediyorum
            </div>
        </label>
    )
}